module.exports = __webpack_public_path__ + "static/media/bpls-signature.8b353f6e.svg";